import zod from 'zod';
import { stringToBoolean, stringToListOfNumber, zodLimit, zodPage } from './helpers';

export const cameraTypes = [
    'ptz',
    'panoramic',
    'lpr',
    'pinned',
] as const;

export type CameraType = typeof cameraTypes[number];

export const algorithmFilter = [
    'hasFacial',
    'hasLpr',
    'hasAreaInvasion',
] as const;

export type AlgorithmFilter = typeof algorithmFilter[number];

export const integrationTypes = [
    'type_1',
    'type_2',
    'type_3',
] as const;

export type IntegrationType = typeof integrationTypes[number];


export const CamerasListSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    online: stringToBoolean,
    offline: stringToBoolean.optional(),
    tagsIds: stringToListOfNumber.optional(),
    type: zod.enum(cameraTypes).optional(),
    integrationType: zod.array(zod.enum(integrationTypes)).optional(),
    // TODO: remove when migrated to thirdPartyApprovedCompanies
    origin: zod.string().optional(),
    polygonType: zod.string().optional(),
    polygon: zod.coerce.number().optional(),
    // TODO: Add when migrated to thirdPartyApprovedCompanies
    // imageProvider: zod.string().optional(),
    // cloudProvider: zod.string().optional()
});

export const MosaicSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

export const CameraTagsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

export const DownloadTagsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

export const DownloadsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    tagsIds: stringToListOfNumber.optional(),
    userId: zod.coerce.number().optional(),
    cameraId: zod.string().optional(),
});

export const AlertGroupsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

export const CamerasReportsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

export const VideoAnalysisSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    status: zod.string().optional(),
    startDate: zod.coerce.number().optional(),
    endDate: zod.coerce.number().optional(),
    requesterUserId: zod.coerce.number().optional(),
});

export const CameraDetailsSchema = zod.object({
    id: zod.string(),
});

export const MosaicDetailSchema = zod.object({
    id: zod.coerce.number(),
});

export const VideoAnalysisDetailsSchema = zod.object({
    id: zod.coerce.number(),
});
